export default "__VITE_ASSET__Ba$yP_OL__"